import { Box, Typography } from '@mui/material'
import { IconLink } from 'assets/icons'
import { SettingsItem } from 'components/global'
import { Dialog } from 'elements/feedback'
import { Button } from 'elements/inputs'
import { useBoolean } from 'lib/hooks'
import { useTranslation } from 'react-i18next'

import { LinkProjectForm } from './link-project-form'

type LinkedProjectBlockProps = {
  projectId: string
  linkedProjectName?: string
}

export const LinkedProjectBlock = ({
  projectId,
  linkedProjectName,
}: LinkedProjectBlockProps) => {
  const { t } = useTranslation()

  const isOpen = useBoolean()

  return (
    <>
      <SettingsItem
        title={t('projects.settings.link_project.linked_project')}
        customButton={
          linkedProjectName ? undefined : (
            <Button
              variant="text"
              sx={{ color: 'primary.main' }}
              onClick={isOpen.setTrue}
            >
              {t('projects.settings.link_project.link_project')}
            </Button>
          )
        }
      >
        <Typography
          variant="caption2"
          color="text.secondary"
          maxWidth={600}
          display="block"
        >
          {t('projects.settings.link_project.linked_project_info')}
        </Typography>

        {linkedProjectName && (
          <Box display="flex" alignItems="center" mt={1.5}>
            <IconLink sx={{ color: 'primary.main' }} />
            <Typography variant="caption2" fontWeight={600}>
              {linkedProjectName}
            </Typography>
          </Box>
        )}
      </SettingsItem>

      <Dialog open={isOpen.isTrue} onClose={isOpen.setFalse}>
        <LinkProjectForm projectId={projectId} onClose={isOpen.setFalse} />
      </Dialog>
    </>
  )
}
